(function(root, factory) {
  'use strict';

  if (typeof module === 'object' && module.exports && typeof document === 'undefined') {
    module.exports = factory(null, null);
    return;
  }

  factory(root, root.document).init();
}(typeof window !== 'undefined' ? window : this, function(window, document) {
  'use strict';

  function normalizeThreshold(value) {
    var threshold = parseInt(value, 10);
    return threshold > 0 ? threshold : 5;
  }

  function shouldShowLowStock(variant, threshold) {
    if (!variant || !variant.available) {
      return false;
    }

    if (variant.inventory_management !== 'shopify' || variant.inventory_policy === 'continue') {
      return false;
    }

    var quantity = parseInt(variant.inventory_quantity, 10);
    return quantity >= 1 && quantity <= normalizeThreshold(threshold);
  }

  function getVariantById(variants, id) {
    var target = String(id);

    for (var index = 0; index < variants.length; index += 1) {
      if (String(variants[index].id) === target) {
        return variants[index];
      }
    }

    return null;
  }

  function parseVariants(rootElement) {
    var dataId = rootElement.getAttribute('data-xpertza-variant-data-id');
    var dataElement = dataId ? document.getElementById(dataId) : null;

    if (!dataElement) {
      return [];
    }

    try {
      return JSON.parse(dataElement.textContent || dataElement.innerHTML || '[]');
    } catch (error) {
      return [];
    }
  }

  function renderLowStock(element, variant, threshold) {
    if (!element) {
      return;
    }

    if (shouldShowLowStock(variant, threshold)) {
      element.textContent = 'Only ' + parseInt(variant.inventory_quantity, 10) + ' left in stock';
      element.hidden = false;
      return;
    }

    element.textContent = '';
    element.hidden = true;
  }

  function renderProductStatus(element, variant) {
    if (!element) {
      return;
    }

    element.hidden = !variant || variant.available !== false;
    element.textContent = element.hidden ? '' : (element.getAttribute('data-xpertza-sold-out-text') || '');
  }

  function initRoot(rootElement) {
    if (rootElement.getAttribute('data-xpertza-product-cro-initialized') === 'true') {
      return;
    }

    var sectionId = rootElement.getAttribute('data-xpertza-section-id');
    var section = document.getElementById('ProductSection-' + sectionId);
    var form = document.getElementById('AddToCartForm-' + sectionId);
    var masterSelect = form ? form.querySelector('[name="id"]') : null;
    var lowStock = rootElement.querySelector('[data-xpertza-low-stock]');
    var productStatus = section ? section.querySelector('[data-xpertza-product-status]') : null;
    var threshold = normalizeThreshold(rootElement.getAttribute('data-xpertza-low-stock-threshold'));
    var variants = parseVariants(rootElement);

    if (!section || !form || !masterSelect || !window.jQuery) {
      return;
    }

    rootElement.setAttribute('data-xpertza-product-cro-initialized', 'true');
    var initialVariant = getVariantById(variants, masterSelect.value);
    renderLowStock(lowStock, initialVariant, threshold);
    renderProductStatus(productStatus, initialVariant);

    window.jQuery(section)
      .off('variantChange.xpertzaProductCro')
      .on('variantChange.xpertzaProductCro', function(event) {
        renderLowStock(lowStock, event.variant || null, threshold);
        renderProductStatus(productStatus, event.variant || null);
      });
  }

  function initAll(container) {
    var scope = container && container.querySelectorAll ? container : document;
    var roots = scope.querySelectorAll('[data-xpertza-product-cro]');

    for (var index = 0; index < roots.length; index += 1) {
      initRoot(roots[index]);
    }
  }

  function init() {
    if (!document) {
      return;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      initAll(event.target);
    });
  }

  return {
    getVariantById: getVariantById,
    init: init,
    normalizeThreshold: normalizeThreshold,
    renderProductStatus: renderProductStatus,
    shouldShowLowStock: shouldShowLowStock
  };
}));
